import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logoo.png';

const Sidebar = ({ sidebarOpen, setSidebarOpen, activePage, onLogout }) => {
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = React.useState(null);

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      iconWhite: '/images/dashboardWhite.png',
      iconBrown: '/images/dashboard.jpg',
      path: '/dashboard'
    },
    { id: 'create-script', label: 'Create Scripts', icon: '/images/createScripts.png', path: '/create-script' },
    { id: 'my-scripts', label: 'My Scripts', icon: '/images/MyScripts.png', path: '/my-scripts' },
    { id: 'topic-library', label: 'Topic Library', icon: '/images/TopicLibrary.png', path: '/topic-library' },
    { id: 'settings', label: 'Settings', icon: '/images/settings.png', path: '/settings' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  return (
    <aside className={`
      fixed lg:relative top-0 left-0 h-screen w-64 flex-shrink-0
      gradient-sidebar text-white z-50
      ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      transition-transform duration-300 lg:transition-none
    `}>
      <div className="flex flex-col h-full">
        <div className="p-6 flex justify-center">
          <button
            onClick={() => handleNavigation('/dashboard')}
            className="focus:outline-none hover:opacity-80 transition-opacity duration-200 cursor-pointer"
            aria-label="Go to Dashboard"
          >
            <img src={logo} alt="ScriptWriter Logo" className="h-16 w-auto" />
          </button>
        </div>

        <nav className="flex-1 px-4 space-y-2 overflow-y-auto">
          {menuItems.map((item) => {
            const isActive = activePage === item.id;
            const isHovered = hoveredItem === item.id;

            // For dashboard, use different icons for active/inactive/hover states
            let iconSrc;
            let iconClass;

            if (item.iconWhite && item.iconBrown) {
              // Dashboard has separate white and brown icons
              iconSrc = (isActive || isHovered) ? item.iconBrown : item.iconWhite;
              iconClass = 'sidebar-icon-no-filter';
            } else {
              // Other icons use CSS filters
              iconSrc = item.icon;
              iconClass = isActive ? 'sidebar-icon-active' : 'sidebar-icon';
            }

            return (
              <div
                key={item.id}
                onClick={() => handleNavigation(item.path)}
                onMouseEnter={() => setHoveredItem(item.id)}
                onMouseLeave={() => setHoveredItem(null)}
                className={isActive ? 'sidebar-item-active' : 'sidebar-item'}
              >
                <img
                  src={iconSrc}
                  alt={item.label}
                  className={iconClass}
                />
                <span className="font-medium whitespace-nowrap">{item.label}</span>
              </div>
            );
          })}

          <div
            className="sidebar-item"
            onClick={onLogout}
          >
            <img src="/images/logout.png" alt="Logout" className="sidebar-icon" />
            <span className="font-medium whitespace-nowrap">Logout</span>
          </div>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
